import { ShellA } from "@/components/konsept-a/shell";
import { DashboardA } from "@/components/konsept-a/dashboard";

export function KonseptA() {
  return (
    <ShellA>
      <DashboardA />
    </ShellA>
  );
}
